import { useEffect } from "react";
import { gmsIndexFeed } from "../../../Services/Feed/FeedApiService";
import { useAuthHeader } from "../../../auth/AuthService";
import { useState } from "react";

export default function GmsIndex() {
    const authHeader = useAuthHeader();
    const [data, setData] = useState();
    const [xmlText, setXmlText] = useState('');

    function downloadURI() {
        let currentIndex = '-';
        let OPIndex = '-';
        let HPIndex = '-';
        let LPIndex = '-';
        let CIndex = '-';
        let PDayIndex = '-';
        let TQuantity = '-';
        let TTurnover = '-';
        let created = '-';
        let cpday = '';
        switch (data?.marketStatus) {
            case "EOD":
                currentIndex = data?.index[0]?.cindex;
                OPIndex = data?.index[0]?.opindex;
                HPIndex = data?.index[0]?.hpindex;
                LPIndex = data?.index[0]?.lpindex;
                CIndex = data?.index[0]?.cindex;
                PDayIndex = data?.index[0]?.pdayindex;
                TQuantity = data?.index[0]?.tquantity;
                TTurnover = data?.index[0]?.tturnover;
                break;
            case "IN_SESSION":
                currentIndex = data?.index?.cindex;
                cpday = data?.index?.cpday;
                TQuantity = data?.index?.tquantity;
                TTurnover = data?.index?.tturnover;
                created = data?.index?.created;
                break;
            default: 
                currentIndex = data?.index?.cindex;
                created = data?.index?.created;
            break;
        }


        var text = `<rss xmlns:dc="http://purl.org/dc/elements/1.1/" version="2.0">
    <channel>
        <title>CSX INDEX DATA FEED</title>
        <link>${window.location.origin}</link>
        <description>CSX Index real-time updates.</description>
        <language>en-us</language>
        <item>
            <title>CSX Index</title>
            <description>CSX Index</description>
            <price>${currentIndex}</price>
            <change>${cpday}</change>
            <trading_quantity>${TQuantity}</trading_quantity>
            <trading_value>${TTurnover}</trading_value>
            <opening_index>${OPIndex}</opening_index>
            <high_index>${HPIndex}</high_index>
            <low_index>${LPIndex}</low_index>
            <closing_index>${CIndex}</closing_index>
            <previous_day_index>${PDayIndex}</previous_day_index>
            <pubDate>${created}</pubDate>
        </item>
    </channel>
</rss>`;

console.log(text);
        setXmlText(text);


        // var filename = "index.rss";
        // var pom = document.createElement('a');
        // var bb = new Blob([xmltext], {type: 'text/plain'});

        // pom.setAttribute('href', window.URL.createObjectURL(bb));
        // pom.setAttribute('download', filename);

        // pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
        // pom.draggable = true; 
        // pom.classList.add('dragout');

        // pom.click();
    }

    async function getIndex() {
        await gmsIndexFeed(authHeader())
        .then((response) => {
            setData(response?.data?.data);
        }) 
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        getIndex();
    }, [])

    useEffect(() => {
        data?.marketStatus && downloadURI();
    }, [data?.marketStatus])

    return (
        xmlText
    )
}